import React from "react";

const CookieBanner = ({ onAccept, onDecline }) => (
  <div style={{
    position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999,
    background: "#1E2A3A", color: "white", padding: "1rem 2rem",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    gap: "1rem", flexWrap: "wrap", fontFamily: "'Syne', sans-serif", fontSize: "13px"
  }}>
    <p style={{ margin: 0, color: "rgba(255,255,255,0.75)", maxWidth: "700px", lineHeight: 1.6 }}>
      We use cookies to improve your experience. By continuing, you agree to our{" "}
      <a href="/privacy" style={{ color: "#7BBF6A" }}>Cookie Policy</a>.
    </p>
    <div style={{ display: "flex", gap: "8px" }}>
      <button onClick={onDecline} style={{
        background: "transparent", border: "1px solid rgba(255,255,255,0.25)",
        color: "rgba(255,255,255,0.6)", padding: "8px 18px", borderRadius: "6px",
        cursor: "pointer", fontSize: "12px", fontFamily: "'Syne', sans-serif"
      }}>Decline</button>
      <button onClick={onAccept} style={{
        background: "#4E8A3C", border: "none", color: "white",
        padding: "8px 18px", borderRadius: "6px", cursor: "pointer",
        fontSize: "12px", fontFamily: "'Syne', sans-serif"
      }}>Accept</button>
    </div>
  </div>
);

export default CookieBanner;